export default __webpack_public_path__ + "static/profile-5bd2e923edc25f071f21119fa52699c3.png";